import { t } from "i18next"
import React, { useCallback, useEffect, useState } from "react"
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useLocation } from "react-router-dom"
import { CardBody } from "../../../../../_metronic/_partials/controls"
import { EmptyCard, TableSkeleton, TableView } from "../../../../../component"
import { DetailSvgIcon } from "../../../../../component/atoms/Icons/SVG"
import { formatterRowComponent, initialFilterTable } from "../../../../../component/atoms/Tabel"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { getListHistoryTarget } from "../../../../../redux/actions/FieldOfficerAction.jsx"
import { stringFormatting, toThousandConvert } from "../../../../helpers/TextHelper"
import { getUrlParsingPageFilter } from "../../../../../config/EndpointCollection.js"
import { ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { UNIT_STRING } from "../../../../../constants/StringConstant.js"
export function KpiGoalSettingHistory({regionalId}) {
  const dispatch = useDispatch()
  const { General, FieldOfficer } = useSelector((state) => state)
  const history = useHistory()
  const location = useLocation()

  const [currentParam] = useState({
    ...initialFilterTable
  })

  const changePage = useCallback(
    (param) => {
      let urlParam
      if (param.sortField != null) {
        urlParam = getUrlParsingPageFilter({
          ...param,
          sort: param?.sortField ? param.sortField + "," + param.sortOrder : ""
        })
      } else {
        urlParam = getUrlParsingPageFilter({
          ...param
        })
      }
      history.push({ pathname: location.pathname, search: urlParam })
    },
    [dispatch, currentParam]
  )

  useEffect(() => {
    const result = location?.search
    if (regionalId) {
      dispatch(getListHistoryTarget(regionalId, result))
    }
  }, [location.search])

  const tableColumn = [
    {
      text: t("label_year"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={"font-weight-bolder font-size-lg"}>{stringFormatting(e?.year)}</div>
          </>
        )
      }
    },
    {
      text: t("label_paddy") + ` (${UNIT_STRING.HA})`,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={" font-size-lg"}>{stringFormatting(toThousandConvert(e?.paddy))} {UNIT_STRING.HA}</div>
          </>
        )
      }
    },
    {
      text: t("label_corn") + ` (${UNIT_STRING.HA})`,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={" font-size-lg"}>{stringFormatting(toThousandConvert(e?.corn))} {UNIT_STRING.HA}</div>
          </>
        )
      }
    },
    {
      text: t("label_corn_production") + ` (${UNIT_STRING.HA})`,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={" font-size-lg"}>{stringFormatting(toThousandConvert(e?.corn_production))} {UNIT_STRING.HA}</div>
          </>
        )
      }
    },
    {
      text: t("label_detail"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <Link to={RoutesConstants.FIELD_OFFICER.DETAIL_KPI_TARGET_KPI_BY_YEAR(e.year, regionalId)}>
            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Detail {e.regional_name}</Tooltip>}>
              <div className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-3">
                <DetailSvgIcon />
              </div>
            </OverlayTrigger>
          </Link>
        )
      }
    }
  ]

  return (
    <div>
      <Card className="mt-4">
        <CardBody>
          {General?.loading ? (
            <TableSkeleton column={5} row={10} />
          ) : FieldOfficer?.pageData && FieldOfficer?.pageData.length === 0 ? (
            <EmptyCard
              image={ILLUSTRATION_CONSTANTS.EMPTY_STATE_DESKTOP}
              body={t("messages_response_empty_state_history")}
            />
          ) : (
            ""
          )}
          <TableView
            callbackAfterPageChange={changePage}
            dataTable={FieldOfficer?.pageData || []}
            currentPage={FieldOfficer?.page?.currentPage || 1}
            currentElement={FieldOfficer?.page?.currentElement ?? 10}
            totalCount={FieldOfficer?.page?.totalCount ?? 0}
            columnProperties={tableColumn}
            loadingGetData={General?.loading}
            ignoreSinglePage
          />
        </CardBody>
      </Card>
    </div>
  )
}